import { Component, OnInit } from '@angular/core';

import * as AuthenticateReducer from '@store/auth/reducers';
import {Store} from '@ngrx/store';
import {Permission} from '@models/permission';
import {UserInterface} from '@interfaces/user.interface';
import {AuthState, State} from '@store/auth/reducers';
import {PermissionFacade} from '@facades/permission/permissionFacade';
import {User} from '@models/user';
import {AuthFacade} from '@facades/auth/authFacade';
import {ActivatedRoute, NavigationEnd, Router} from '@node_modules/@angular/router';
import {SignOut, UpdateAuthUser} from '@store/auth/actions';
import {RemoveAllPrograms,SetPrograms} from '@store/program/actions';
import * as ProgramReducer from '@store/program/reducers';
import {CreateSchoolComponent} from '@pages/layout/school/create-school/create-school.component';
// import {SchoolDropdownComponent} from '@pages/layout/school/school-dropdown/school-dropdown.component';
import {MatDialog} from '@node_modules/@angular/material';
import {SetStudents} from '@store/student/actions';
import {SetTeachers} from '@store/teacher/actions';
import {TeacherService} from '@services/teacher/teacher.service';
import {ProgramService} from '@services/program/program.service';
import {SchoolService} from '@services/school/school.service';
import {StudentService} from '@services/student/student.service';
import * as StudentReducer from '@store/student/reducers';
import * as TeacherReducer from '@store/teacher/reducers';
import {Program} from '@models/program';
import {AccountService} from "@services/account/account.service";

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit {
  permissions: {
    key?: [Permission]
  };
  user: User;
  currentUrl = '';
  schools = [];
  family = [];

  constructor(
      private route: Router,
      private authFacade: AuthFacade,
      private authStore: Store<AuthenticateReducer.AuthState>,
      private programStore: Store<ProgramReducer.ProgramState>,
      public dialog: MatDialog,
      private router: ActivatedRoute,
      public  accountService: AccountService,
      private studentService: StudentService,
      private teacherService: TeacherService,
      private programService: ProgramService,
      private schoolService: SchoolService,
      private studentStore: Store<StudentReducer.StudentState>,
      private teacherStore: Store<TeacherReducer.TeacherState>,


  ) {
    route.events.subscribe((val: NavigationEnd) => this.currentUrl = val.url);
    authStore.subscribe(
      (val) => {
        const auth = val.auth;
        if (auth.user && auth.user.permissions) {
          this.user = AuthFacade.getUser();
          this.schools = this.user.schools ? this.user.schools : [];
        }
      }
    );
  }

  ngOnInit() {
    this.family = this.user.family;
  }

  onSelectedSchools(select) {
    const selected = select.id ? select.id : select;
    this.authStore.dispatch(new UpdateAuthUser({activeSchool : selected}));
    this.programStore.dispatch(new RemoveAllPrograms());
    let url = this.route.url;
    window.location.reload();
    // switch(url) {
    //   case '/students':
    //     this.studentService.getAll()
    //       .subscribe(
    //         (resp: {data: User[]}) => {
    //           this.studentStore.dispatch(new SetStudents(resp.data));
    //         }
    //       );
    //     break;
    //   case '/teachers':
    //     this.teacherService.getAll()
    //       .subscribe(
    //         (resp: {data: User[]}) => {
    //           this.teacherStore.dispatch(new SetTeachers(resp.data));
    //         }
    //       );
    //     break;
    //   case '/program':
    //     this.programService.getAll()
    //       .subscribe(
    //         (resp : {data: [Program]}) => {
    //           this.programStore.dispatch(new SetPrograms(resp.data));
    //         }
    //       );
    //     break;
    //   default:
    //     window.location.reload();
    // }
  }

  checkPermission( modelName, event = '', type = '') {
    return PermissionFacade.checkPermission(this.permissions, modelName, event, type);
  }

  checkPermissionsToAccessPage(page) {
    return PermissionFacade.checkPermissionsToAccessPage(page, this.user);
  }
  isActivePage(page: string) {
    if (this.currentUrl && this.currentUrl.includes('/attendance/detail') && page === '/attendance') {
      return true;
    }
    return this.currentUrl === page;
  }
  onLogout() {
    this.authStore.dispatch(new SignOut(this.authFacade));
    this.programStore.dispatch(new RemoveAllPrograms());
  }

  openCreateModal() {
    const dialogRef = this.dialog.open(CreateSchoolComponent);
    dialogRef.afterClosed().subscribe(result => {
      dialogRef.close();
    });
  }

  toProfilePage() {
    this.route.navigate(['/profile']);
  }

  // toSelectSchool() {
  //   const dialogRef = this.dialog.open(SchoolDropdownComponent);
  //   dialogRef.afterClosed().subscribe(result => {
  //     dialogRef.close();
  //   });
  // }
}
